module.exports = __webpack_public_path__ + "img/nejm_nejm_logo.b937e928.png";